import { defineStore } from "pinia";

import {
  ACTION_EXTRA_GET_BY_ID,
  ACTION_EXTRA_GET_BIO_BY_ID,
  ACTION_EXTRA_GET_LANGUAGE_BY_ID,
  ACTION_EXTRA_GET_SKILLS_BY_ID,
  ACTION_EXTRA_GET_SKILLS,
  ACTION_EXTRA_GET_COURSES,
  ACTION_EXTRA_GET_EXPERIENCES,
  GETTER_EXTRA_GET_CURRENT,
  GETTER_EXTRA_GET_SKILLS,
  GETTER_EXTRA_GET_BIO,
  GETTER_EXTRA_GET_LANGUAGE,
  GETTER_EXTRA_GET_EXTRA_SKILLS,
  GETTER_EXTRA_GET_HACCP_CERTIF,
  GETTER_EXTRA_GET_COURSES,
  GETTER_EXTRA_GET_EXPERIENCES,
} from "@etab/stores/types";
import { ExtraModel } from "@core/models";
import { ExtraService } from "@core/services";

export const useExtraStore = defineStore("extra", {
  // convert to a function
  state: () => ({
    extra: {},
    skills: [],
    extraBio: {},
    extraLanguage: {},
    extraSkills: {},
    extraCourse: {},
    extraExperiences: {},
  }),
  getters: {
    [GETTER_EXTRA_GET_CURRENT]: (state) => new ExtraModel(state.extra),
    [GETTER_EXTRA_GET_SKILLS]: (state) => state.skills,
    [GETTER_EXTRA_GET_BIO]: (state) => state.extraBio,
    [GETTER_EXTRA_GET_LANGUAGE]: (state) => state.extraLanguage,
    [GETTER_EXTRA_GET_EXTRA_SKILLS]: (state) => state.extraSkills.skills,
    [GETTER_EXTRA_GET_HACCP_CERTIF]: (state) => state.extraSkills.haccp_verified,
    [GETTER_EXTRA_GET_COURSES]: (state) => state.extraCourse,
    [GETTER_EXTRA_GET_EXPERIENCES]: (state) => state.extraExperiences,
  },
  actions: {
    async [ACTION_EXTRA_GET_BY_ID]({ extraId, demandId, type }) {
      const extra = await ExtraService.getById({ extraId, demandId, type });
      this.extra = extra;
    },
    async [ACTION_EXTRA_GET_SKILLS_BY_ID]({ candidateId }) {
      const skills = await ExtraService.getSkillsById({ candidateId });
      this.skills = skills;
    },
    async [ACTION_EXTRA_GET_BIO_BY_ID]({ repository, candidateId, demandId }) {
      const bio = await ExtraService.getBioById({ repository, candidateId, demandId });
      this.extraBio = bio;
    },
    async [ACTION_EXTRA_GET_LANGUAGE_BY_ID]({ repository, candidateId, demandId }) {
      const language = await ExtraService.getLanguageById({ repository, candidateId, demandId });
      this.extraLanguage = language;
    },
    async [ACTION_EXTRA_GET_SKILLS]({ repository, candidateId, demandId }) {
      const extraSkills = await ExtraService.getSkills({ repository, candidateId, demandId });
      this.extraSkills = extraSkills;
    },
    async [ACTION_EXTRA_GET_COURSES]({ repository, candidateId, demandId }) {
      const courses = await ExtraService.getCourses({ repository, candidateId, demandId });
      this.extraCourse = courses;
    },
    async [ACTION_EXTRA_GET_EXPERIENCES]({ repository, candidateId, demandId }) {
      const experiences = await ExtraService.getExperiences({ repository, candidateId, demandId });
      this.extraExperiences = experiences;
    },
    // easily reset state using `$reset`
    clearExtraStore() {
      this.$reset();
    },
  },
});
